import { render, staticRenderFns } from "./TmsTable.vue?vue&type=template&id=2692e7f2&scoped=true&"
import script from "./TmsTable.vue?vue&type=script&lang=ts&"
export * from "./TmsTable.vue?vue&type=script&lang=ts&"
import style0 from "./TmsTable.vue?vue&type=style&index=0&id=2692e7f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2692e7f2",
  null
  
)

export default component.exports